import { PageId } from 'constants/pages'

export const enum PageIdWoofzNpday80 {
  SUBSCRIPTIONS_NPDAY_80 = PageId.SUBSCRIPTIONS_NPDAY_80,
  CHAT_UPSELL_NPDAY_80 = PageId.CHAT_UPSELL_NPDAY_80,
  UPSELL_NPDAY_80 = PageId.UPSELL_NPDAY_80,
  DOWNLOAD_NPDAY_80 = PageId.DOWNLOAD_NPDAY_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
